export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePhone = (phone) => {
  // Kenyan phone numbers: 07XXXXXXXX or 2547XXXXXXXX
  const re = /^(0|254)?[17]\d{8}$/;
  return re.test(phone.replace(/\D/g, ''));
};

export const validatePassword = (password) => {
  // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return re.test(password);
};

export const validatePositiveNumber = (value) => {
  const num = parseFloat(value);
  return !isNaN(num) && num >= 0;
};

export const validateRequired = (value) => {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  return value !== null && value !== undefined;
};

export const validateSKU = (sku) => {
  // SKU format: alphanumeric, hyphens, underscores, 3-20 chars
  const re = /^[a-zA-Z0-9_-]{3,20}$/;
  return re.test(sku);
};

export const validateBarcode = (barcode) => {
  // EAN-13 or UPC-A
  const re = /^\d{12,13}$/;
  return re.test(barcode);
};